import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-tab-connect-service';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export enum FpLoggerNoiseManagerActionType {
  Init = 'Init',
  SelectedDataUpdated = 'SelectedDataUpdated',
  ChangeTab = 'ChangeTab',
  GlobalDataLoadingStateChanged = 'GlobalDataLoadingStateChanged',
}

export interface FpLoggerNoiseManagerActionInit {
  type: FpLoggerNoiseManagerActionType.Init;
  popupId: string;
  activeTab: FpLoggerNoiseTabs;
  selectedData: ILdLogger | null;
}

export interface FpLoggerNoiseManagerActionGetSelectedDataUpdated {
  type: FpLoggerNoiseManagerActionType.SelectedDataUpdated;
  selectedData: ILdLogger | null;
}

export interface FpLoggerNoiseManagerActionChangeTab {
  type: FpLoggerNoiseManagerActionType.ChangeTab;
  activeTabConnectService: IFpLoggerNoiseTabConnectService | null;
}

export interface FpLoggerNoiseManagerActionGlobalDataLoadingStateChanged {
  type: FpLoggerNoiseManagerActionType.GlobalDataLoadingStateChanged;
  loading: boolean;
}

export type FpLoggerNoiseManagerActions =
  | FpLoggerNoiseManagerActionInit
  | FpLoggerNoiseManagerActionGlobalDataLoadingStateChanged
  | FpLoggerNoiseManagerActionGetSelectedDataUpdated
  | FpLoggerNoiseManagerActionChangeTab;
